import { render, staticRenderFns } from "./EditRolesPopover.vue?vue&type=template&id=39894105&scoped=true&"
import script from "./EditRolesPopover.vue?vue&type=script&lang=js&"
export * from "./EditRolesPopover.vue?vue&type=script&lang=js&"
import style0 from "./EditRolesPopover.vue?vue&type=style&index=0&id=39894105&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39894105",
  null
  
)

export default component.exports